// extracted by mini-css-extract-plugin
export const bio = "bio-module--bio--9bxVk";
export const bioAvatar = "bio-module--bioAvatar--12fWO";